module.exports = __webpack_public_path__ + "img/waistband width.81b1bc37.png";